/* eslint-disable -- Not a standard file */
import 'react-app-polyfill/stable'

global.Buffer = global.Buffer || require('buffer').Buffer
